import { FC } from "react";
import { Button, Card, Input } from "@components";
import { formatDate } from "@utilities/functions";

import { MyAccountFormProps } from "./interfaces";

export const MyAccountForm:FC<MyAccountFormProps> = ({
    user, isUserInfosIsComplete,
    isLoadingUpdatedUser,
    updateUserError,
    isEditing, isValid,
    firstname, setFirstname,
    lastname, setLastname,
    phone, setPhone,
    email, setEmail,
    birth, setBirth,
    onToggleEdit,
    handleUpdatedUserInfos,
}) => {

    return (
        <Card title="Informations personnelles" collapsible>
            {!isEditing ? (
                <div className="space-y-2">
                    <p><strong>Nom :</strong> {user?.firstname}</p>
                    <p><strong>Prénom :</strong> {user?.lastname}</p>
                    <p><strong>Téléphone :</strong> {user?.phone}</p>
                    <p><strong>Email :</strong> {user?.email}</p>
                    <p><strong>Date de naissance :</strong> {user?.birthDate ? formatDate(user?.birthDate) : "Date inconnue"}</p>
                    <p><strong>Crée le :</strong> {user?.createAt ? formatDate(user?.createAt) : "Date inconnue"}</p>
                    <Button
                        type="button"
                        className="w-full btn-primary rounded-md mt-4"
                        onClick={onToggleEdit}
                    >
                        Modifier les informations
                    </Button>
                </div>
            ) : (
                <div className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <Input
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                            placeholder="Prénom"
                        />
                        <Input
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                            placeholder="Nom"
                        />
                        <Input
                            type="tel"
                            pattern="[0-9]{10}"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Téléphone"
                        />
                        <Input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email"
                            disabled
                        />
                        <Input
                            type="date"
                            value={birth}
                            onChange={(e) => setBirth(e.target.value)}
                            placeholder="Date de naissance"
                        />
                    </div>

                    <div className="flex justify-between">
                        <Button
                            onClick={handleUpdatedUserInfos}
                            className="btn-success rounded-md"
                            disabled={isLoadingUpdatedUser || !isValid}
                        >
                            {isLoadingUpdatedUser ? "Mise à jour en cours..." : "Mettre à jour"}
                        </Button>
                        {
                            isUserInfosIsComplete && (
                                <Button
                                    type="button"
                                    className="btn-secondary rounded-md"
                                    onClick={onToggleEdit}
                                    disabled={isLoadingUpdatedUser}
                                > Annuler</Button>
                            )
                        }
                    </div>

                    {updateUserError && (
                        <p className="text-red-500 text-sm mt-2">{updateUserError?.message}</p>
                    )}
                </div>
            )}
        </Card>
    );
};
